import * as React from 'react';
import { StyleSheet } from 'react-native';

import { DefaultLayout } from '../DefaultLayout';
import { WebCard } from '../WebCard';
import { spacing } from '../../theme';

type Props = React.ComponentProps<typeof DefaultLayout>;

export const WebLayout = ({ children, style, ...layoutProps }: Props) => {
	return (
		<DefaultLayout style={styles.root} {...layoutProps}>
			<WebCard style={[styles.container, style]}>{children}</WebCard>
		</DefaultLayout>
	);
};

const styles = StyleSheet.create({
	root: {
		flex: 1,
		padding: spacing(4),
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
	container: {
		width: '100%',
	},
});
